import { format, parseISO } from "date-fns";

export const formatDate = (value) => {
  if (!value) return "-";
  return format(parseISO(value), "dd MMM yyyy");
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  return format(parseISO(value), "dd MMM yyyy HH:mm");
};

const formatJakartaDate = (value, options) => {
  if (!value) return "-";
  const date = new Date(value);
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    ...options,
  });
  return formatter.format(date).replace(/,/g, "");
};

export const formatDateJakarta = (value) =>
  formatJakartaDate(value, { day: "2-digit", month: "short", year: "numeric" });

export const formatDateTimeJakarta = (value) =>
  formatJakartaDate(value, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

export const formatDateInputValue = (value) => {
  if (!value) return "";
  return format(parseISO(value), "yyyy-MM-dd");
};

export const parseDateInput = (value) => {
  if (!value) return null;
  return new Date(value).toISOString();
};

export const formatJakartaStartOfDay = (value) => {
  if (!value) return "";
  return `${value}T00:00:00+07:00`;
};

export const formatJakartaEndOfDay = (value) => {
  if (!value) return "";
  return `${value}T23:59:59+07:00`;
};
